import React, { useEffect, useState } from 'react';

/**
 * トーストUIコンポーネントのプロパティ
 */
export interface ToastProps {
  /** 表示するメッセージ */
  message: string;
  /** トーストの表示時間（ミリ秒） */
  duration?: number;
  /** トーストが閉じられた時のコールバック */
  onClose?: () => void;
  /** トーストの表示状態 */
  visible: boolean;
}

/**
 * トーストUIコンポーネント
 *
 * 一時的なメッセージを表示するためのトーストUI。
 * 指定された時間が経過すると自動的に消える。
 */
export function Toast({ message, duration = 3000, onClose, visible }: ToastProps) {
  const [isVisible, setIsVisible] = useState(visible);

  // visibleプロパティが変更されたときに内部状態を更新
  useEffect(() => {
    setIsVisible(visible);
  }, [visible]);

  // 表示時間が経過したら自動的に閉じる
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) {
          onClose();
        }
      }, duration);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isVisible, duration, onClose]);

  // 表示されていない場合は何も表示しない
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className='toast-notification'
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.87)',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '345px',
        height: '48px',
        borderRadius: '8px',
        zIndex: 30000,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        fontSize: '14px',
        fontWeight: 'normal',
        pointerEvents: 'auto',
        fontFamily:
          '"メイリオ", Meiryo, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        animation: 'fadeIn 0.3s, fadeOut 0.3s 2.7s'
      }}
    >
      {message}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translate(-50%, calc(-50% + 20px));
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%);
          }
        }
        @keyframes fadeOut {
          from {
            opacity: 1;
            transform: translate(-50%, -50%);
          }
          to {
            opacity: 0;
            transform: translate(-50%, calc(-50% + 20px));
          }
        }
      `}</style>
    </div>
  );
}
